module.exports = __webpack_public_path__ + "media/images/OR_Logo_White-8ca8ed66a455e71135a80e425e818401.svg";